import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import PaymentTypeList from './PaymentTypeList';
import PaymentTypeForm from './PaymentTypeForm';
import DeletedPaymentTypesList from './DeletedPaymentTypesList';

const PaymentTypes = () => {
  return (
    <Routes>
      <Route path="/" element={<PaymentTypeList />} />
      <Route path="/new" element={<PaymentTypeForm />} />
      <Route path="/:id/edit" element={<PaymentTypeForm />} />
      <Route path="/deleted" element={<DeletedPaymentTypesList />} />
      <Route path="*" element={<Navigate to="/payment-types" replace />} />
    </Routes>
  );
};

export default PaymentTypes;
